export default __webpack_public_path__ + "static/media/help-illustration03.33491fcb.svg";